// @ts-nocheck

import arrowLeftIcon from '../../images/icons/arrow-left.svg';
import arrowRightIcon from '../../images/icons/arrow-right.svg';
import cancelIcon from '../../images/icons/cancel.svg';
import checkIcon from '../../images/icons/check.svg';
import checkboxIcon from '../../images/icons/checkbox.svg';
import editIcon from '../../images/icons/edit.svg';
import logoIcon from '../../images/icons/logo.svg';
import profileIcon from '../../images/icons/profile.svg';
import spinnerIcon from '../../images/icons/spinner--spokes.svg';
import trashIcon from '../../images/icons/trash.svg';

export default {
  'arrow-left': arrowLeftIcon,
  'arrow-right': arrowRightIcon,
  cancel: cancelIcon,
  check: checkIcon,
  checkbox: checkboxIcon,
  edit: editIcon,
  logo: logoIcon,
  profile: profileIcon,
  'hyp-spinner': spinnerIcon,
  trash: trashIcon,
};
